/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToRem, mediaQuery } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORT : COMMENTING CONFIGURATION: COMMENTS TREE SECTION : STYLES --------------- ++++++++++ */
export default theme => ({
    commentstreesection: {
        '& .collapsable.opened': {
            maxHeight: pxToRem(4000)
        },
        '& .commentstreecontent': {
            display: 'flex',
            marginBottom: pxToRem(8),
            '& .commentstreeoptions': {
                backgroundColor: '#ffffff',
                maxWidth: pxToRem(480),
                marginRight: pxToRem(4),
                '& .cardcontrol': {
                    minWidth: pxToRem(180),
                    '&.selected-true': {
                        '& .content': {
                            paddingRight: 0
                        }
                    }
                },
                '& .customfields': {
                    display: 'flex',
                    flexFlow: 'wrap',
                    '& > .customfieldscontent': {
                        marginTop: pxToRem(8),
                        marginRight: pxToRem(8)
                    },
                    '& .incdecfield': {
                        height: pxToRem(48),
                        margin: `${pxToRem(8)} 0`,
                        cursor: 'default !important',
                        '& .field': {
                            pointerEvents: 'none'
                        },
                    },
                    '& label': {
                        fontSize: pxToRem(14)
                    }

                }
            },
            '& .commentstreepreview': {
                marginLeft: pxToRem(4),
                width: '100%',
                maxWidth: pxToRem(360),
                height: 'inherit',
                textAlign: 'center',
                '& .previewcontent': {
                    marginBottom: 'auto'
                },
                '& .button.name-preview': {
                    width: '100%',
                    height: pxToRem(48),
                    fontSize: pxToRem(14),
                    fontWeight: 500,
                    background: '#ffffff',
                    borderTop: '1px solid rgb(236, 240, 247)'
                },
                '& .previewimg': {
                    maxWidth: pxToRem(268),
                    width: '100%',
                    marginBottom: pxToRem(32)
                },
                '& > .sectioncard': {
                    height: '100%',
                    padding: `${pxToRem(32)} 0 0`,
                    paddingBottom: 0,
                    display: 'flex',
                    flexFlow: 'column'
                },
                '& h2': {
                    fontSize: pxToRem(16)
                },
                '& p': {
                    fontSize: pxToRem(14),
                    margin: `${pxToRem(16)} 0`
                },
                '& .listtable': {
                    maxWidth: pxToRem(268),
                    margin: '0 auto',
                    fontSize: pxToRem(14),
                    color: 'rgb(130, 149, 186)',
                    '& .innerhead': {
                        display: 'block'
                    },
                    '& th': {
                        textAlign: 'center',
                        background: 'rgba(6, 43, 117, 0.05)',
                        padding: pxToRem(8)
                    },
                    '& td': {
                        textAlign: 'center',
                        background: '#ffffff',
                        padding: pxToRem(8),
                        left: `-${pxToRem(8)}`
                    },
                    '& tr:nth-child(1) td': {
                        borderTop: 0
                    },
                    '& .headicon': {
                        color: '#ffffff',
                        fontWeight: 'bold',
                        position: 'absolute',
                    },
                    '& .headtext': {
                        position: 'relative'
                    },
                    '& .commentsicon': {
                        left: pxToRem(8)
                    },
                    '& .commentstext': {
                        left: `-${pxToRem(8)}`
                    },
                    '& .repliesicon': {
                        right: pxToRem(8)
                    },
                    '& .repliestext': {
                        right: pxToRem(8)
                    },
                }
            }
        },
        '& .limitsection': {
            '& .sectiongroupdescription > h2': {
                marginBottom: pxToRem(8)
            },
            '& .commentslimit': {
                display: 'flex',
                '& > .commentslimiticon': {
                    height: pxToRem(64),
                    width: pxToRem(64),
                    marginRight: pxToRem(16)
                },
                '& > .sectiongroup': {
                    marginTop: 0
                }
            },
            '& .replieslimit': {
                marginLeft: pxToRem(80),
                marginTop: pxToRem(48)
            },
            '& > .sectioncard': {
                padding: pxToRem(32)
            },
            '& .controlgroup': {
                '& > .group': {
                    display: 'flex',
                    flexFlow: 'row wrap',
                    marginTop: pxToRem(16),
                    '& .control': {
                        width: pxToRem(64),
                        minWidth: pxToRem(64),
                        maxWidth: pxToRem(64),
                        flex: 1,
                    }
                }
            }
        }
    },
    [mediaQuery.medium]: {
        commentstreesection: {
            '& .commentstreecontent': {
                flexFlow: 'wrap',
                '& .commentstreeoptions': {
                    width: '100%',
                    maxWidth: '100%',
                    marginBottom: pxToRem(8),
                    marginRight: 0
                },
                '& .commentstreepreview': {
                    width: '100%',
                    maxWidth: '100%'
                }
            },
            '& .control': {
                marginBottom: pxToRem(8)
            }
        }
    }
});
